declare global {
  interface Window {
    __RUNTIME_CONFIG__?: Record<string, string>;
  }
}

export function getRuntimeConfig() {
  return globalThis.window === undefined
    ? {}
    : (globalThis.window.__RUNTIME_CONFIG__ ?? {});
}

/**
 * Gets environment variable from the appropriate source
 * - In production (browser): reads from window.__RUNTIME_CONFIG__
 * - In development: reads from import.meta.env (Vite dev server)
 *
 * @param key - The environment variable key
 * @returns The environment variable value or empty string if not found
 */
export function getEnv(key: string, fallback = ""): string {
  // In production, use runtime config
  if (globalThis.window?.__RUNTIME_CONFIG__) {
    const config = getRuntimeConfig();
    return config[key] || fallback;
  }

  // In development, use Vite's import.meta.env
  return import.meta.env[key] || fallback;
}
